// extracted by mini-css-extract-plugin
module.exports = {"location-info-card":"A2hbK","location-title":"mJ1uF","location-info":"K+N8J"};